import React from "react";
import PageTitle from "../../../components/pagetitle/PageTitle";

const Jenjangonl24 = () => {
  return (
    <>
      <PageTitle menuback="Category Page" backbtn="/kategori25" motherMenu="List of Winners Online" activeMenu="/ 2025" />

      <section className="faq-section">
        <div className="container text-center">
            <h1>Choose based on the Level of the Online event you are participating in</h1>
          <div className="hero-btn text-center">
            <a className="btn m-2" href="https://drive.google.com/file/d/1AjRSqBzkgD6JbyOwfINH2Rv-thCn10PG/view?usp=sharing" target="_blank" rel="noreferrer">University</a>
            <a className="btn m-2" href="https://drive.google.com/file/d/15LU_TTZwOCKtq9p06QGDMsfajM7m0OdA/view?usp=sharing" target="_blank" rel="noreferrer">Senior High School</a>
            <a className="btn m-2" href="https://drive.google.com/file/d/1lkq-ISKYgB4is-q_u3OfsQl6AmGGKphY/view?usp=sharing" target="_blank" rel="noreferrer">Junior High School</a>
            <a className="btn m-2" href="https://drive.google.com/file/d/19_PHHje4N756awlv5nptddpSu6eziVfh/view?usp=sharing" target="_blank" rel="noreferrer">Elementary School</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Jenjangonl24;
